export const isValueDefined = value => Boolean(value || value === 0);
